module.exports = " <div class=social-list> <p class=header>Get Connected</p> <ul class=stack-vertical> <li class=stack-vertical__item v-for=\"item in itemList\"> <span class=\"socicon--single socicon-{{item.service}}\"></span> <a v-bind:href=item.url class=text-link>{{item.displayString || item.url}}</a> </li></ul> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialList.vue
 ** module id = 14
 ** module chunks = 1
 **/